<template>
    <div
        class="rlms-flex rlms-items-center rlms-justify-between rlms-flex-wrap rlms-gap-10 rlms-border-bottom rlms-pb-4">
        <div class="rlms-fs-lg rlms-fw-600">Subscription</div>
        <RouterLink :to="`/organizations/${organizationId}/subscription/cart`" class="rlms-cart-menu">
            <img :src="blade1" width="24" height="24" alt="">
            <div class="rlms-cart-menu-item-index" id="cartItem">{{ cartStore?.cartCount }}</div>
            <p>Cart</p>
        </RouterLink>
    </div>
    <template v-if="products.length > 0">
        <p class="rlms-fs-md rlms-fw-600">Available Assessments</p>

        <div class="product-box" v-for="product in products" :key="product.id">
            <div class="product-box-image">
                <img :src="productImg">
            </div>
            <div class="product-box-content">
                <div class="product-bc-head">
                    <p class="rlms-fs-md rlms-fw-700">{{ product?.name }}</p>
                </div>
                <div class="product-bc-body">
                    <div class="product-desc">{{ product?.description }}</div>
                    <div class="product-quantity">
                        <span class="rlms-fw-600 rlms-fs-xs">Quantity</span>
                        <div class="rlms-quantity-control">
                            <div class="quantity-decrease"
                                @click="cartStore.setQty(product.id, cartStore.getQty(product.id) - 1)">
                                <img :src="minus" alt="Decrease" />
                            </div>
                            <input type="number" :value="cartStore.getQty(product.id)"
                                @input="cartStore.setQty(product.id, +$event.target.value)" />
                            <div class="quantity-increase"
                                @click="cartStore.setQty(product.id, cartStore.getQty(product.id) + 1)">
                                <img :src="plus" alt="Increase" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="product-bc-footer">
                    <div class="rlms-flex rlms-items-center rlms-flex-wrap rlms-gap-5">
                        <p class="rlms-fs-xl rlms-fw-700 rlms-text-primary-500 rlms-flex rlms-items-center">
                            {{ formatCurrency(product?.price) }}
                            <span class="rlms-fs-xxs rlms-fw-400 rlms-text-extra-3">/Per Year</span>
                        </p>
                        <span class="product-price-badge">Per Learner</span>
                    </div>
                    <button class="rlms-btn rlms-btn-primary add-to-cart" @click="cartStore.addToCart(product.id)">
                        Add to Cart
                    </button>
                </div>
            </div>
        </div>
    </template>
</template>
<script setup>
import productImg from "@/assets/images/product-image1.png";
import api from "@/services/axios";
import { useCartStore } from "@/stores/cart";
import { useLoaderStore } from "@/stores/loader";
import { formatCurrency } from "@/utils/format-helpers";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import plus from '@/assets/images/plus.svg'
import minus from '@/assets/images/minus.svg'
import blade1 from '@/assets/images/index_blade_093916a9.svg'
import { handleError } from "@/utils/handleError";

const route = useRoute();
const loader = useLoaderStore();
const organizationId = Number(route.params.organization ?? 0);
const products = ref([]);
const languages = ref([]);

const cartStore = useCartStore();

onMounted(async () => {
    await init();
})

const init = async () => {
    await getData();
}

const getData = async () => {
    try {
        loader.show();

        const { data } = await api.get('/products');

        products.value = data.data;
        cartStore.initializeProductStates(products.value);

        if (products.value.length > 0 && languages.value.length > 0) {
            cartStore.setLanguage(products.value[0].id, languages.value[0].id);
        }
    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
}
</script>